import download from 'downloadjs';
import {trackEvent, CLICK} from '../../../services/mixpanel';
import {formatNumbersWithUnits, formatRawNumbers} from '../../../utils/formatNumbers';
import {sanitiseString} from '../../../utils/summaryPageHelpers';

export const dataToCSV = (columns, rows, dataKey, raw = false) => {
    // column headings
    let payload = `,${columns
        .map(({label}) => sanitiseString(label))
        .join(',')}\r\n`;

    // data
    rows.forEach((row) => {
        const {label, cols} = row;
        payload += `${sanitiseString(label)},${cols
            .map((entry) => {
                const {unitType, prefix} = entry;
                return raw
                    ? `${formatRawNumbers(entry[dataKey])}`
                    : `${prefix}${formatNumbersWithUnits(entry[dataKey], unitType)}`;
            })
            .join(',')}\r\n`;
    });
    return payload;
}

export const downloadData = (columns, rows, dataKey, filename, raw = false) => {
    const payload = dataToCSV(columns, rows, dataKey, raw);
    const fullFilename = filename ? `${filename}.csv` : 'widget-data.csv';
    download(payload, fullFilename, 'text/csv');
    trackEvent(CLICK, {
        element: 'row widget CSV download',
    });
};
